import React from 'react';
import Header from './Header';
import Footer from './Footer';
import CartDrawer from '../cart/CartDrawer';
import NotificationContainer from '../ui/NotificationContainer';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      background: 'var(--color-bg-secondary)',
    }}>
      <Header />
      
      <main id="main-content" style={{
        flex: 1,
        padding: '2rem 0',
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 20px',
        }}>
          {children}
        </div>
      </main>

      <Footer />
      
      {/* Global components */}
      <CartDrawer />
      <NotificationContainer />
    </div>
  );
};

export default Layout;